import React from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import { colors } from "src/assets";
import { OfferListItemLarge } from "src/components";
import { NotFound } from "./components";
import { useLike } from "src/hooks";
import { useNavigation } from "@react-navigation/native";
import { RootStackScreenProps } from "src/navigation/types";

export const LikedServiceScreen: React.FC = () => {
  const navigation =
    useNavigation<RootStackScreenProps<"LikedService">["navigation"]>();
  const [items, loading] = useLike();
  return (
    <View style={styles.container}>
      {items.length > 0 ? (
        <ScrollView>
          {items.map((item) => (
            <OfferListItemLarge
              key={item.id}
              userName={item.owner?.name}
              userImageSource={
                item.owner?.image ? { uri: item.owner?.image } : undefined
              }
              offerName={item.title}
              offerImageSource={
                item.mainImageUrl ? { uri: item.mainImageUrl } : undefined
              }
              categoryName={item.category?.title || "unknown"}
              price={item.price || 0}
              status={item.owner?.status}
              likes={item.likeCount}
              isVerified={item.owner?.identificationStatus === "APPROVED"}
              onPress={() => navigation.push("Offer", { offerId: item.id })}
            />
          ))}
        </ScrollView>
      ) : null}
      {items.length === 0 && !loading ? <NotFound /> : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.gray1,
  },
});
